import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { WalletTypeEnum } from '@model/WalletDto'

export const useDepositWallets = (walletType: WalletTypeEnum) => {
  const apiClient = useApiClient(ClientApiClient)

  const { data: wallets, isLoading: isWalletsLoading } = useQuery({
    queryKey: queryKeys.deposit.wallets(walletType),
    queryFn: () => apiClient.getWallets({ walletTypeId: walletType }),
    refetchOnMount: 'always',
  })

  return { wallets: wallets ?? [], isWalletsLoading }
}
